import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectBusinessRoute: InvariantJiraRoute = {
	name: 'issue-navigator-core',
	path: '/jira/core/projects/:projectKey/issues/:navigationItemId?',
};
